<div class="modal-header">
    <div class="modal-title">The Form is not filled in order to proceed to the next stage.</div>
    <button id="invalid-form-close" type="button" class="close" aria-label="Close" (click)="onCancel()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <p>The Form is not filled in order to proceed to the next stage.<br />
        Please check all <span style="color: red; font-weight: bold;">required</span> fields.
    </p>
</div>

<div class="modal-footer">
    <button id="invalid-form-cancel" type="button" class="button secondary__button large__button" (click)="onCancel()">Cancel</button>
</div>